import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import SchemaOrg from '../../components/feature/SchemaOrg';
import MiniPriceSimulator from '../../components/feature/MiniPriceSimulator';
import { useEffect } from 'react';

const blogPosts = [
  {
    slug: 'transporteur-express-ile-de-france-guide',
    title: 'Transporteur Express Île-de-France : Guide Complet 2024',
    excerpt: 'Découvrez tout ce qu\'il faut savoir sur les transporteurs express en Île-de-France : services, tarifs, délais et conseils pour choisir le meilleur prestataire.',
    category: 'Guide Expert',
    date: '28 janvier 2024',
    readTime: '12 min',
    image: 'https://public.readdy.ai/ai/img_res/742d0cfa028b35ea90b269e019841413.jpg'
  },
  {
    slug: 'coursier-paris-choisir-service',
    title: 'Coursier Paris : Comment Choisir le Bon Service en 2024',
    excerpt: 'Guide pratique pour sélectionner le meilleur service de coursier à Paris. Critères essentiels, comparatif des offres et conseils d\'experts pour vos livraisons urgentes.',
    category: 'Conseils Pratiques',
    date: '27 janvier 2024',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20motorcycle%20courier%20in%20Paris%20streets%20fast%20delivery%20service%20urban%20logistics%20modern%20bike%20messenger%20efficient%20transport%20city%20background%20clean%20setting&width=800&height=500&seq=blog-coursier-paris&orientation=landscape'
  },
  {
    slug: 'livraison-urgente-delais-tarifs',
    title: 'Livraison Urgente : Délais et Tarifs en Île-de-France',
    excerpt: 'Tout savoir sur la livraison urgente en Île-de-France : délais garantis, grille tarifaire détaillée, options express et conseils pour optimiser vos coûts.',
    category: 'Tarifs & Délais',
    date: '26 janvier 2024',
    readTime: '9 min',
    image: 'https://readdy.ai/api/search-image?query=urgent%20delivery%20service%20with%20timer%20clock%20fast%20transport%20in%20Ile-de-France%20express%20logistics%20professional%20courier%20with%20package%20time-sensitive%20delivery%20modern%20setting%20clean%20background&width=800&height=500&seq=blog-livraison-urgente&orientation=landscape'
  },
  {
    slug: 'livraison-dernier-kilometre-paris',
    title: 'Livraison dernier kilomètre à Paris : enjeux et solutions',
    excerpt: 'Découvrez les défis de la livraison dernier kilomètre à Paris et nos solutions logistiques professionnelles pour optimiser vos livraisons urbaines.',
    category: 'Logistique Urbaine',
    date: '20 janvier 2024',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=last%20mile%20delivery%20logistics%20in%20Paris%20urban%20setting%20professional%20courier%20with%20electric%20vehicle%20modern%20city%20streets%20efficient%20transport%20sustainable%20delivery%20solution%20clean%20background&width=800&height=500&seq=blog-dernier-kilometre&orientation=landscape'
  },
  {
    slug: 'transport-urgent-weekend-paris',
    title: 'Transport urgent le week-end à Paris : comment ça marche ?',
    excerpt: 'Besoin d\'un transport urgent le week-end ? Découvrez notre service 24/7, les tarifs, délais et solutions pour vos livraisons express samedi et dimanche.',
    category: 'Service 24/7',
    date: '22 janvier 2024',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=weekend%20urgent%20delivery%20service%20in%20Paris%20professional%20courier%20working%20on%20saturday%20and%20sunday%20emergency%20transport%20fast%20logistics%20modern%20urban%20setting%20motorcycle%20delivery%20clean%20background&width=800&height=500&seq=blog-weekend&orientation=landscape'
  },
  {
    slug: 'choisir-transporteur-paris-guide',
    title: 'Comment choisir son transporteur à Paris : guide complet',
    excerpt: 'Guide expert pour sélectionner le meilleur transporteur à Paris. Critères essentiels, checklist pratique et conseils pour faire le bon choix.',
    category: 'Guide Expert',
    date: '25 janvier 2024',
    readTime: '10 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20transport%20company%20selection%20guide%20Paris%20logistics%20comparison%20checklist%20business%20decision%20making%20modern%20office%20setting%20professional%20meeting%20discussing%20delivery%20options%20clean%20background&width=800&height=500&seq=blog-guide&orientation=landscape'
  },
  {
    slug: 'transport-colis-paris',
    title: 'Comment envoyer un colis rapidement à Paris ?',
    excerpt: 'Découvrez les meilleures solutions pour envoyer un colis rapidement à Paris. Comparatif des services, tarifs et conseils pratiques.',
    category: 'Conseils Pratiques',
    date: '15 janvier 2024',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20courier%20delivering%20package%20in%20Paris%20streets%20with%20motorcycle%20fast%20delivery%20service%20modern%20urban%20logistics%20parcel%20box%20in%20hands%20efficient%20transport&width=800&height=500&seq=blog1&orientation=landscape'
  },
  {
    slug: 'demenagement-conseils-paris',
    title: '10 conseils pour un déménagement réussi à Paris',
    excerpt: 'Préparez votre déménagement à Paris avec nos 10 conseils d\'experts. Organisation, timing, astuces pour un déménagement sans stress.',
    category: 'Déménagement',
    date: '12 janvier 2024',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=professional%20moving%20service%20in%20Paris%20apartment%20with%20boxes%20furniture%20transport%20organized%20relocation%20team%20efficient%20packing%20clean%20modern%20interior%20successful%20move&width=800&height=500&seq=blog2&orientation=landscape'
  },
  {
    slug: 'coursier-moto-vs-utilitaire',
    title: 'Coursier moto ou utilitaire : que choisir à Paris ?',
    excerpt: 'Moto ou utilitaire pour vos livraisons à Paris ? Comparatif complet des avantages, inconvénients et cas d\'usage pour faire le bon choix.',
    category: 'Comparatif',
    date: '10 janvier 2024',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=comparison%20between%20motorcycle%20courier%20and%20delivery%20van%20in%20Paris%20city%20traffic%20urban%20logistics%20professional%20transport%20services%20side%20by%20side%20modern%20vehicles%20efficient%20delivery&width=800&height=500&seq=blog3&orientation=landscape'
  }
];

export default function BlogPage() {
  useEffect(() => {
    document.title = 'Blog Transporteur Express IDF | Coursier Paris, Déménagement, Utilitaire avec Chauffeur';

    const metaTags = [
      { name: 'description', content: 'Blog Transporteur Express IDF : conseils coursier Paris, aide au déménagement, location camion utilitaire avec chauffeur, aide au chargement. Guides pratiques et astuces transport.' },
      { name: 'keywords', content: 'blog transporteur express IDF, conseils coursier Paris, aide au déménagement Paris, location camion utilitaire avec chauffeur, aide au chargement Paris, livraison express Paris, transport colis Paris, déménagement Paris, guide pratique transport, coursier moto Paris, livraison urgente IDF' },
      { name: 'geo.region', content: 'FR-IDF' },
      { name: 'geo.placename', content: 'Paris, Île-de-France' },
      { name: 'geo.position', content: '48.8566;2.3522' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Blog Transporteur Express IDF | Coursier Paris, Déménagement, Utilitaire avec Chauffeur' },
      { name: 'twitter:description', content: 'Blog Transporteur Express IDF : conseils coursier Paris, aide au déménagement, location camion utilitaire avec chauffeur, aide au chargement. Guides pratiques et astuces transport.' }
    ];

    metaTags.forEach(({ name, content }) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = 'https://transporteurexpressidf.fr/blog';
  }, []);

  return (
    <>
      <SchemaOrg type="blog" />
      <Navbar />
      <WhatsAppButton phoneNumber="0631012910" />

      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-br from-teal-500 to-emerald-600 text-white py-20 pb-16">
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="text-5xl font-bold mb-6">Blog Transport Paris</h1>
              <p className="text-xl text-white/90">
                Conseils d'experts, guides pratiques et actualités sur le transport, la livraison et le déménagement à Paris
              </p>
            </div>
          </div>
        </section>

        {/* Mini Price Simulator */}
        <MiniPriceSimulator />

        {/* Articles Grid */}
        <section className="py-20">
          <div className="container mx-auto px-4">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {blogPosts.map((post) => (
                <article key={post.slug} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <Link to={`/blog/${post.slug}`}>
                    <div className="relative w-full h-64">
                      <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </Link>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <span className="inline-block px-3 py-1 bg-teal-100 text-teal-700 text-sm font-medium rounded-full">
                        {post.category}
                      </span>
                      <time className="text-sm text-gray-500">
                        {new Date(post.date).toLocaleDateString('fr-FR', {
                          year: 'numeric',
                          month: 'long',
                          day: 'numeric'
                        })}
                      </time>
                    </div>
                    <h2 className="text-2xl font-bold mb-3 text-gray-900 hover:text-teal-600 transition-colors">
                      <Link to={`/blog/${post.slug}`}>{post.title}</Link>
                    </h2>
                    <p className="text-gray-600 mb-4 leading-relaxed">
                      {post.excerpt}
                    </p>
                    <Link
                      to={`/blog/${post.slug}`}
                      className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors"
                    >
                      Lire la suite
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-gradient-to-r from-teal-500 to-emerald-600">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Besoin d'un transport à Paris ?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Contactez-nous dès maintenant pour un devis gratuit et un service rapide
            </p>
            <a
              href="tel:+33632410246"
              className="inline-block bg-white text-teal-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-50 transition-colors shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line mr-2"></i>
              Appelez-nous : +33 6 32 41 02 46
            </a>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
